import scrollMonitor from 'scrollmonitor'

class Navigation {
  constructor () {
    this._element = document.querySelector('.js-site-header')
    this._burgerBtn = this._element.querySelector('.js-site-burger-btn')
    this._colorChangeElements = document.querySelectorAll('.js-navi-color-change')
    this._initialize()
  }

  _initialize () {
    this._burgerBtn.addEventListener('click', this.onBurgerClick.bind(this))


    for (let i = 0; i < this._colorChangeElements.length; i++) {
      let section = this._colorChangeElements[i]
      let watcher = scrollMonitor.create(section)
      let onScrollCallback = this._update.bind(this, section)

      watcher.enterViewport(() => {
        window.addEventListener("scroll", onScrollCallback);
      })

      watcher.exitViewport(() => {
        this._element.classList.remove('black')
        window.removeEventListener("scroll", onScrollCallback);
      })

      this._update(section)
    }
  }

  _update (section) {
    const headerOffset = (this._element.offsetWidth < 760) ? 70 : 144
    let rect = section.getBoundingClientRect()

    if(rect.top < headerOffset) {
      this._element.classList.add('black')
    } else {
      this._element.classList.remove('black')
    }
  }

  onBurgerClick (event) {
    this._element.classList.toggle('is-open')
  }
}

export default new Navigation()
